import styled from "styled-components";

export const Content = styled.div`
  flex: 1;
  background: white;
  display: flex;
  color: black;
`;

export const ProductImage = styled.div`
  width: 60%;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
`;

export const ProductInfo = styled.div`
  margin-left: 20px;
  display: flex;
  flex-direction: column;
  justify-content:  space-between;
  align-items: center;
  padding: 40px;
  color: #06081B;
`;

export const Title = styled.h1`
color: #06081B;
`;

export const Description = styled.p`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 20px;
  color: rgba(125, 124, 124, 1);
`;

export const Button = styled.button`
  align-self: flex-end;
  background-color: rgba(40, 44, 52, 1);
  color: rgb(255, 255, 255);
  border: 1px solid rgba(40, 44, 52, 1);
  padding: 10px 30px;
  border-radius: 30px;
  font-size: 0.9em;
  cursor: pointer;

  &:hover {
    background-color: rgba(234, 11, 42, 1);
    border: 1px solid rgba(234, 11, 42, 1);
    color: white;
  }`

export const ProductImageSectionColor = styled.div`
  background: var(--INYECTABLE, linear-gradient(180deg, #040916 0%, #0B1733 100%));
  height: 50%;
`

export const ProductImageSection = styled.div`
display: flex;
align-items: center;
justify-content: center;
height: 50%;
background-color: rgba(242, 242, 242, 1);

img{
  position: absolute;
  width: 30%;
  top: 30em;
  z-index: 2;
}

div{
    position: absolute;
    width: 500px;
    height: 500px;
    border-radius: 50%;
    background-color: #0B1733;
    z-index: 1;
    top: 25em;
}
`

export const Options = styled.div`
display: flex;


p{
  margin-right: 20px;
  text-transform: uppercase;
  font-weight: 400;
  cursor: pointer;

  &:hover{
    text-decoration: underline;
  }
}
`

export const DescriptionProduct = styled.div`
  width: 80%;
  margin-top: 20px;
`

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 40px;

`

export const ButtonRight = styled.div`
display: flex;
width: 100%;
align-items: center;
justify-content: center;
&:hover{
  cursor: pointer;
  color: #e30016;
}

`

export const ButtonLeft = styled.div`
display: flex;
width: 100%;
align-items: center;
justify-content: center;
width: 100%;
border-top: 2px solid #000000;
margin-top: 5px;
padding-top: 5px;

&:hover{
  cursor: pointer;
  color: #e30016;
}
`

export const MoreButton = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`